import { AxiosError } from "axios";
import { createMutation } from "react-query-kit";

import { Payment } from "./GetPayment";
import { privateApi, ErrorResponse } from "api";

export type VoidPaymentResult = Payment | null;
export type VoidPaymentParams = {
    id: string;
    reason?: string | null;
};

async function voidPayment({ id, ...params }: VoidPaymentParams): Promise<VoidPaymentResult> {
    // ensure payment id was provided
    if (!id) {
        throw new TypeError('Id is a required parameter');
    }

    // make api call
    const result = await privateApi.patch<VoidPaymentResult>(`${import.meta.env.VITE_API_BASE_URL}/finance/payments/${id}/void`, params);

    // return the data object
    return result.data;
}

const useVoidPayment = createMutation<VoidPaymentResult, VoidPaymentParams, AxiosError<ErrorResponse>>({
    mutationFn: async (variables: VoidPaymentParams) => voidPayment(variables),
});

export { voidPayment, useVoidPayment };
